export default __webpack_public_path__ + "static/media/zip.e32ca0c3.svg";